function showWorkState (num) {
  if (num == 1) {
    return "待处理";
  } else if (num == 2) {
    return "待面试";
  } else if (num == 3) {
    return "面试未通过";
  } else if (num == 4) {
    return "待入职";
  } else if (num == 5) {
    return "未入职";
  } else if (num == 6) {
    return "已入职";
  } else if (num == 7) {
    return "已离职(非自离)";
  } else if (num == 8) {
    return "已离职";
  }
}




let workStateList = [
  {
    text: "待处理",
    value: 1,
  },
  {
    text: "待面试",
    value: 2,
  },
  {
    text: "面试未通过",
    value: 3,
  },
  {
    text: "待入职",
    value: 4,
  },
  {
    text: "未入职",
    value: 5,
  },
  {
    text: "已入职",
    value: 6,
  },
  {
    text: "已离职",
    value: 8,
  },
  {
    text: "已离职(非自离)",
    value: 7,
  },
]

let personneStateList = [
   {
    text: "已入职",
    value: "已入职",
  },
  {
    text: "项目入职",
    value: "项目入职",
  },
  {
    text: "已离职",
    value:"已离职",
  },
  {
    text: "离职(非自离)",
    value: "已离职(非自离)",
  },
]
//职位类型
let posTypes = [
   {
    text: "暑假工",
    value: "暑假工",
  },
  {
    text: "正式工",
    value: "正式工",
  },
  {
    text: "实习生",
    value:"实习生",
  },
  {
    text: "临时工",
    value: "临时工",
  },
]
let employmentTypeList = [
  {
    text: "临时工",
    value: "临时工",
  },
  {
    text: "直招",
    value:"直招",
  },
  {
    text: "劳务派遣",
    value: "劳务派遣",
  },
    {
    text: "钟点工",
    value: "钟点工",
  },
  {
    text: "实习",
    value: "实习",
  },
  {
    text: "暑假工",
    value: "暑假工",
  },
  {
    text: "寒假工",
    value: "寒假工",
  },
  {
    text: "兼职",
    value: "兼职",
  },
]
let weChatError = {
  'ACCOUNT_FROZEN': '该用户账户被冻结',
  'REAL_NAME_CHECK_FAIL': '收款人未实名认证，需要用户完成微信实名认证',
  'NAME_NOT_CORRECT': '收款人姓名校验不通过，请核实信息',
  'OPENID_INVALID': 'Openid格式错误或者不属于商家公众账号',
  'TRANSFER_QUOTA_EXCEED': '超过用户单笔收款额度，核实产品设置是否准确',
  'DAY_RECEIVED_QUOTA_EXCEED': '超过用户单日收款额度，核实产品设置是否准确',
  'MONTH_RECEIVED_QUOTA_EXCEED': '超过用户单月收款额度，核实产品设置是否准确',
  'DAY_RECEIVED_COUNT_EXCEED': '超过用户单日收款次数，核实产品设置是否准确',
  'PRODUCT_AUTH_CHECK_FAIL': '未开通该权限或权限被冻结，请核实产品权限状态',
  'OVERDUE_CLOSE': '超过系统重试期，系统自动关闭',
  'ID_CARD_NOT_CORRECT': '收款人身份证校验不通过，请核实信息',
  'ACCOUNT_NOT_EXIST': '该用户账户不存在',
  'TRANSFER_RISK': '该笔转账可能存在风险，已被微信拦截',
  'OTHER_FAIL_REASON_TYPE': '其它失败原因',
  'REALNAME_ACCOUNT_RECEIVED_QUOTA_EXCEED': '用户账户收款受限，请引导用户在微信支付查看详情',
  'RECEIVE_ACCOUNT_NOT_PERMMIT': '未配置该用户为转账收款人，请在产品设置中调整，添加该用户为收款人',
  'PAYEE_ACCOUNT_ABNORMAL': '用户账户收款异常，请联系用户完善其在微信支付的身份信息以继续收款',
  'PAYER_ACCOUNT_ABNORMAL': '商户账户付款受限，可前往商户平台获取解除功能限制指引',
  'TRANSFER_SCENE_UNAVAILABLE': '该转账场景暂不可用，请确认转账场景ID是否正确',
  'TRANSFER_SCENE_INVALID': '你尚未获取该转账场景，请确认转账场景ID是否正确',
  'TRANSFER_REMARK_SET_FAIL': '转账备注设置失败， 请调整后重新再试',
  'RECEIVE_ACCOUNT_NOT_CONFIGURE': '请前往商户平台-商家转账到零钱-前往功能-转账场景中添加',
  'BLOCK_B2C_USERLIMITAMOUNT_BSRULE_MONTH': '超出用户单月转账收款20w限额，本月不支持继续向该用户付款',
  'BLOCK_B2C_USERLIMITAMOUNT_MONTH': '用户账户存在风险收款受限，本月不支持继续向该用户付款',
  'MERCHANT_REJECT': '商户员工（转账验密人）已驳回转账',
  'MERCHANT_NOT_CONFIRM': '商户员工（转账验密人）超时未验密'
}
export { showWorkState, workStateList, weChatError, personneStateList,posTypes,employmentTypeList }
